import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpService } from '../core/http.service';
import { GlobalsService } from '../globals.service';
import { GroupShare } from 'src/app/models/services/admin/groups-share/groupShare';

@Injectable({ providedIn: 'root' })
export class GroupShareService {

  private readonly baseUrl = `${environment.adminServicesApiBaseUri}/group-share/groups`;

  constructor(
    private httpService: HttpService,
    private globalsService: GlobalsService
  ) {}

  public getGroups(): Observable<GroupShare[]> {
    return this.httpService.get(
      this.baseUrl,
      this.globalsService.getActiveCompany()?.id
    );
  }

  public createGroupShare(groupShare: GroupShare): Observable<GroupShare> {
    return this.httpService.post(this.baseUrl, groupShare, this.globalsService.getActiveCompany()?.id, true);
  }

  public updateGroupShare(groupId: number, groupShare: GroupShare): Observable<void> {
    const url = `${this.baseUrl}/${groupId}`;
    return this.httpService.putNoResponse(url,groupShare, this.globalsService.getActiveCompany()?.id, true);
  }

  public deleteGroupShare(groupId: number): Observable<void> {
    const url = `${this.baseUrl}/${groupId}`;
    return this.httpService.deleteNoResponse(url, this.globalsService.getActiveCompany()?.id);
  }
}